/**
 * GA4 custom event names (must match Admin → Events → mark as conversion).
 * Do not send PII in params.
 */
export const GA_EVENT_NAMES = {
  CONTACT_FORM_SUBMIT: 'contact_form_submit',
  PHONE_CLICK: 'phone_click',
  EMAIL_CLICK: 'email_click',
};

/**
 * Sends a GA4 event when gtag is present (skipped if blocked or unavailable).
 * @param {string} eventName
 * @param {Record<string, unknown>} [params]
 */
export function trackGaEvent(eventName, params) {
  if (typeof window === 'undefined') return;
  if (typeof window.gtag !== 'function') return;
  window.gtag('event', eventName, params ?? {});
}
